var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Linear/edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.25 2.19727H6.75C3 2.19727 1.5 3.69727 1.5 7.44727V11.9473C1.5 15.6973 3 17.1973 6.75 17.1973H11.25C15 17.1973 16.5 15.6973 16.5 11.9473V10.4473",
    stroke: "#FA5A84",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.0304 2.96123L6.1204 8.87123C5.8954 9.09623 5.6704 9.53873 5.6254 9.86123L5.3029 12.1187C5.1829 12.9362 5.7604 13.5062 6.5779 13.3937L8.8354 13.0712C9.1504 13.0262 9.5929 12.8012 9.8254 12.5762L15.7354 6.66623C16.7554 5.64623 17.2354 4.46123 15.7354 2.96123C14.2354 1.46123 13.0504 1.94123 12.0304 2.96123Z",
    stroke: "#FA5A84",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.1816 3.81055C11.4303 4.69365 11.9016 5.4981 12.5504 6.14683C13.1991 6.79557 14.0035 7.26685 14.8866 7.51555",
    stroke: "#FA5A84",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ea522d8efe5dd036d72c856885363164.svg";
export { ForwardRef as ReactComponent };